import { SKAN_UNIFIED_TABLE } from '../../constants/analytics/contexts';
import { DrilldownMapperService } from '../DrilldownMapperService';

type UnifiedAdsState = {
  selectedColumns?: any[];
  isMigratedToDrilldown?: boolean;
  [SKAN_UNIFIED_TABLE]?: {
    granularity?: string;
    activeMode?: string;
    query: {
      dimensions: string[];
      granularity?: string;
    };
  };
};

export class UnifiedAdsDrilldownMigrator<S extends UnifiedAdsState = UnifiedAdsState> {
  constructor(private drilldownMapperServiceClass: typeof DrilldownMapperService = DrilldownMapperService) {}

  private async buildDrilldownMapperService() {
    return new this.drilldownMapperServiceClass(true);
  }

  async migrate(unifiedAdsState: S) {
    const drilldownMapperService = await this.buildDrilldownMapperService();

    if (!drilldownMapperService.needsMigration(unifiedAdsState)) {
      return;
    }

    drilldownMapperService.setAsMigrated(unifiedAdsState);

    const table = unifiedAdsState[SKAN_UNIFIED_TABLE];

    if (!table) {
      return;
    }

    drilldownMapperService.setActiveMode(table);

    const drilldownMapper = drilldownMapperService.buildDrilldownMapper(
      unifiedAdsState.selectedColumns,
      table.granularity,
      table.query.dimensions
    );

    if (drilldownMapper.needsUpdate()) {
      unifiedAdsState.selectedColumns = drilldownMapper.getSelectedColumns();
      table.granularity = drilldownMapper.getGranularity();
      table.query.granularity = table.granularity;
      table.query.dimensions = drilldownMapper.getDimensions();
    }
  }
}
